import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Repo } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import SpacePath from "components/SpacePath";

const SpaceliftVcsReposTableSpaceCell = ({
  item: repo,
  ...cellProps
}: TableSimpleCellProps<Repo>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {repo.space ? (
        <SpacePath spaceId={repo.space.id} fallbackName={repo.space.name} />
      ) : (
        <TableCellEmpty />
      )}
    </TableSimpleCell>
  );
};

export default SpaceliftVcsReposTableSpaceCell;
